import { render, staticRenderFns } from "./settingCleanStaff.vue?vue&type=template&id=5d37a760"
import script from "./settingCleanStaff.vue?vue&type=script&lang=js"
export * from "./settingCleanStaff.vue?vue&type=script&lang=js"
import style0 from "./settingCleanStaff.vue?vue&type=style&index=0&id=5d37a760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports